import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EMPLOYEE_MANAGE_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const employeeServiceApi = createApi({
  reducerPath: "employeeServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: EMPLOYEE_MANAGE_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: [
    "GetDepartments",
    "GetDepartmentDetails",
    "GetDesignations",
    "GetDesignationDetails",
    "GetEmployees",
    "GetEmployeeDetails",
    "GetEmployeeAdditionalFields",
    "GetEmployeeAdditionalFieldDetails",
    "GetBusinessData",
    "GetDeviceList",
    "GetDeviceAllocated",
    "GetDeviceUnAllocated",
    "GetWorkStations",
    "GetWorkStationDetails",
    "GetKPI",
    "GetSingleKPI",
    "GetOwnKPI",
    "GetOwnKPIByDepartment",
    "GetOwnSingleKPI",
    "GetWorkStations",
    "GetWorkStationDetails",
    "GetAllJobPost",
    "GetJobDetails",
    "GetAppliedJob",
    "GetInterviewList",
    "GetApiToken",
    "GetExpenseUnits",
    "GetExpenseUnitDetails",
  ],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
